export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.07dc5776.jpg";